module.exports = __webpack_public_path__ + "img/warning.ebcac915.svg";